import React, { useEffect, useState } from "react";
import { Col, Container, Row } from "reactstrap";
import JobGridHeader from "./JobGridHeader";
import JobVacancy from "./JobVacancy";
import JobVacancyNew from "./JobVacancyNew";
import Section from "./Section";
import Selected from "./Selected";
import { useLocation } from "react-router-dom";

const JobGrid = () => {
    document.title = "Browse All Jobs - Matrix Executive Search Group";
    const { search } = useLocation();
    const params = new URLSearchParams(search);
    const [filter, setFilter] = useState({
        jobType: params.get("jobType") || "",
        state: params.get("state") || "",
    });

    useEffect(() => {
        setFilter({
            jobType: params.get("jobType") || "",
            state: params.get("state") || "",
        });
    }, [search]);

    return (
        <React.Fragment>
            <Section />
            <section className="section">
                <Container>
                    <JobGridHeader filter={filter} setFilter={setFilter} />
                    {/* <Selected /> */}
                    <Row>
                        <Col lg={12}>
                            <JobVacancy filter={filter} />
                        </Col>
                        {/* <Col lg={6}>
                            <JobVacancyNew />
                        </Col> */}
                    </Row>
                </Container>
            </section>
        </React.Fragment>
    );
};

export default JobGrid;
